// removed by extract-text-webpack-plugin
module.exports = {"root":"clip__root","selected":"clip__selected","clipLink":"clip__clipLink","textLink":"clip__textLink clip__clipLink","thumbLink":"clip__thumbLink clip__clipLink","thumbnailContainer":"clip__thumbnailContainer","thumbnail":"clip__thumbnail","duration":"clip__duration","title":"clip__title","identifier":"clip__identifier","description":"clip__description"};


//////////////////
// WEBPACK FOOTER
// ./src/show-page/components/clip/styles.less
// module id = 488
// module chunks = 1